var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 6.66669C2.6 6.66669 2 7.26669 2 8.00002C2 8.73335 2.6 9.33335 3.33333 9.33335C4.06667 9.33335 4.66667 8.73335 4.66667 8.00002C4.66667 7.26669 4.06667 6.66669 3.33333 6.66669Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66669C11.9334 6.66669 11.3334 7.26669 11.3334 8.00002C11.3334 8.73335 11.9334 9.33335 12.6667 9.33335C13.4 9.33335 14 8.73335 14 8.00002C14 7.26669 13.4 6.66669 12.6667 6.66669Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 6.66669C7.26663 6.66669 6.66663 7.26669 6.66663 8.00002C6.66663 8.73335 7.26663 9.33335 7.99996 9.33335C8.73329 9.33335 9.33329 8.73335 9.33329 8.00002C9.33329 7.26669 8.73329 6.66669 7.99996 6.66669Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.49d60ac8e25553d5da5445f40da37e0f.svg";
export { ForwardRef as ReactComponent };